var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptusProfilePic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-profile-pic",
    transform: "translate(-481 -165)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(485 169)",
    fill: "#d1cedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M20.319,139.921a5.341,5.341,0,1,1-5.342-5.341h0A5.34,5.34,0,0,1,20.319,139.921Z",
    transform: "translate(488.063 42.609)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M17.344,154.3H9.527a4.111,4.111,0,0,0-4.111,4.111v.376A1.411,1.411,0,0,0,6.825,160.2h13.22a1.409,1.409,0,0,0,1.409-1.409v-.376A4.111,4.111,0,0,0,17.344,154.3Z",
    transform: "translate(489.558 35.622)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(482 166)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptusProfilePic);
export default __webpack_public_path__ + "static/media/promptus-profile-pic.3d484efd3a118ac36c0429ec331ee0c2.svg";
export { ForwardRef as ReactComponent };